<template>
    <v-dialog class="help-dialog" v-model="visible" width="600">
        <div class="help-box" :style="style">
            <v-card color="helpColor" class="elevation-3" v-if="!editing">
                <v-card-title class="headline" :style="getPrimaryColorStyle">
                    <v-layout justify-space-between>
                        <v-flex md1>
                            <v-icon color="secondary" style="margin-right:3px;">help_outline</v-icon>
                        </v-flex>
                        <v-flex md10>
                            <p style="word-break:normal;"> {{ ' ' + title }} </p>
                        </v-flex>
                        <v-flex md1 class="text-right">
                            <v-icon color="secondary" @click="visible = false"> close</v-icon>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text class="help-body" :style="getPrimaryColorStyle">
                    {{ body }}
                </v-card-text>
                <v-card-actions>
                    <div v-if="helpEditable">
                        <v-btn @click="editHelp"> Szerkesztés</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
            <v-card v-if="editing">
                <v-card-title>
                    Help szerkesztése
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="title" label="Help mező címe"></v-text-field>
                    <v-textarea v-model="body" label="Help szövege"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="save()"> Mentés</v-btn>
                    <v-btn @click="finishEditing"> Mégse</v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </v-dialog>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';
import EventBus from '../../modules/EventBus';
import { getCookie } from '../../utils/WindowUtils';

export default {

    computed: {
        ...mapGetters({
            isHelpEditable: 'isHelpEditable',
            editing: 'editing',
        }),

        title: {
            get() {
                return this.$store.getters.title;
            },
            set(value) {
                this.$store.commit(
                    'setTitle',
                    value,
                );
            },
        },
        body: {
            get() {
                return this.$store.getters.body;
            },
            set(value) {
                this.$store.commit(
                    'setBody',
                    value,
                );
            },
        },

        ceg() {
            return this.$store.getters.getBroker.ceg;
        },

        getPrimaryColorStyle() {
            return 'color: var(--v-helpTextColor-base);';
        },

        helpEditable() {
            return (
                (
                    [
                        1,
                        462,
                        518,
                    ].includes(this.ceg)
                    && typeof getCookie('BNETAUTH') !== 'undefined')
                || (
                    window.location.href.toString().includes('takarek')
                    && parseInt(
                        this.$store.getters.getBroker.jogosultsag,
                        10,
                    ) === 100
                )
            );
        },

    },

    data() {
        return {
            helpVisible: false,
            visible: false,
            editable: true,
            style: {
                'margin-top': '0px',
            },
        };
    },

    props: {
        modozat: {},
        codename: {},
        help: {
            type: Object,
            default: undefined,
        },
        aktiv: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        ...mapActions([
            'updateHelp',
            'saveHelp',
            'editHelp',
        ]),

        ...mapMutations([
            'setHelp',
            'finishEditing',
            'startEditing',
        ]),

        save() {
            this.$store.commit(
                'setModozat',
                this.modozat,
            );
            this.$store.commit(
                'setCodeName',
                this.codename,
            );
            this.finishEditing();
            this.saveHelp();
        },

        scrollHandler() {
            this.style = {
                'margin-top': `${this.$parent.$parent.$el.scrollTop}px`,
            };
        },
    },

    watch: {
        visible() {
            if (!this.visible) {
                this.$store.commit(
                    'setTitle',
                    '',
                );
                this.$store.commit(
                    'setBody',
                    '',
                );
            }
        },

    },
    mounted() {
        EventBus.$on(
            'show-help',
            () => {
                this.visible = true;
            },
        );

        this.$store.commit(
            'setCodeName',
            this.codename,
        );
        if (!this.aktiv) {
            this.$store.commit(
                'setTitle',
                this.help.title,
            );
            this.$store.commit(
                'setBody',
                this.help.body,
            );
        }

        this.editable = this.$store.getters.getBroker.ceg === 1;
    },
};
</script>
<style scoped>

.help-body {
    text-align: justify;
    white-space: pre-line;
}

.help-box {
    transition: all 0.2s ease-in-out;
}

.help-dialog {
    z-index: 99999;
}
</style>
